module.exports = __webpack_public_path__ + "media/images/badge/apprendista-b2c8c112143f650f0c18fd3a0177e227.png";